<template>
  <div>
    <v-container fluid>
      <template>
        <div class="mb-4">
          <date-filter
            @changeDate="onRefresh"
            :defaultFilter="'last_7_days'"
            v-model="selectedDate"
          ></date-filter>
        </div>
        <div class="mb-4">
          <v-layout wrap>
            <v-flex xs12 sm12 text-xs-right>
              <v-btn
                @click="showImpostCodeModal = true"
                class="primary"
                style="text-transform: uppercase"
              >
                <span>Add Voucher Code</span>
              </v-btn>
              <v-btn outline color="primary" @click="advanceSearchModal = true">
                <v-icon>search</v-icon>
                <span class="pl-2">Advance search</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div class="mb-4">
          <v-layout wrap>
            <v-flex xs12 sm9>
              <div>
                <v-pagination
                  :total-visible="6"
                  v-model="pageNumber"
                  @input="changePage"
                  :length="pagelength"
                ></v-pagination>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <v-data-table
          :headers="headers"
          :items="dataDashboard"
          :loading="loading"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1 mt-4"
          :search="search"
        >
          <!-- hide-actions -->
          <template v-slot:items="props">
            <tr style="cursor: pointer">
              <td>{{ props.item.import_date ? getDateFormatted(props.item.import_date) : '-' }}</td>
              <td>{{ props.item.intentname }}</td>
              <td>{{ props.item.start_date ? getDateFormatted(props.item.start_date) : '-' }}</td>
              <td>{{ props.item.end_date ? getDateFormatted(props.item.end_date) : '-' }}</td>
              <td class="text-xs-center">
                <div style="display: flex; justify-content: center">
                  <div style="margin-top: 11px" class="pr-2">
                    <label class="toggle-switch small" style="vertical-align: bottom">
                      <input
                        type="checkbox"
                        :checked="props.item.open"
                        @change="onChangeStatus(props.item)"
                      />
                      <span class="toggle-slider lever round"></span>
                    </label>
                  </div>
                  <v-btn outline small fab color="primary" @click="onShowCode(props.item)">
                    <em class="fas fa-eye" />
                  </v-btn>
                  <v-btn outline small fab color="primary" @click="onDelete(props.item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </v-container>

    <!-- Advance search Modal -->
    <v-dialog v-model="advanceSearchModal" persistent width="500px">
      <v-card class="pa-3">
        <div class="text-xs-right">
          <v-btn @click="closeSearchModal" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div class="form-control">
          <label>Reply Comment Topic: </label>
          <input v-model="filter.intent" type="text" />
        </div>
        <!-- <div class="form-control mb-0">
          <label>Import Date:</label>
          <DatepickerCustomDialog v-model="filter.import_date">
            <input type="text" readonly :value="getDateFormatted(filter.import_date)" />
          </DatepickerCustomDialog>
        </div> -->
        <div>
          <v-layout wrap>
            <v-flex xs6 class="pr-2">
              <div class="form-control">
                <label>Start Date:</label>
                <DatepickerCustomDialog v-model="filter.voucher_start_date">
                  <input
                    type="text"
                    readonly
                    :value="getDateFormatted(filter.voucher_start_date)"
                  />
                </DatepickerCustomDialog>
              </div>
            </v-flex>
            <v-flex xs6 class="pl-2">
              <div class="form-control">
                <label>End Date:</label>
                <DatepickerCustomDialog
                  v-model="filter.voucher_end_date"
                  :min="filter.voucher_start_date"
                >
                  <input type="text" readonly :value="getDateFormatted(filter.voucher_end_date)" />
                </DatepickerCustomDialog>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <!-- <div class="form-control">
          <label>Status:</label>
          <v-radio-group v-model="filter.status" row class="mt-0">
            <v-radio label="All" value="" color="primary"></v-radio>
            <v-radio label="Open" value="true" color="primary"></v-radio>
            <v-radio label="Close" value="false" color="primary"></v-radio>
          </v-radio-group>
        </div> -->
        <div>
          <v-layout>
            <v-flex class="pr-2">
              <v-btn @click="onSearch" block color="primary" depressed>Search</v-btn>
            </v-flex>
            <v-flex class="pl-2">
              <v-btn @click="clearSearch" block color="grey" outline>Clear</v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-card>
    </v-dialog>

    <!-- Modal Import Code -->
    <v-dialog persistent v-model="showImpostCodeModal" width="600px">
      <ImportCodeModal
        v-if="showImpostCodeModal"
        v-model="dataIntents"
        @close="showImpostCodeModal = false"
        @success="onRefresh"
      ></ImportCodeModal>
    </v-dialog>

    <v-dialog persistent width="950px" v-model="showCodeModal">
      <AllCodeModal
        v-if="showCodeModal"
        @close="onCloseShowCodeModal"
        :selectedData="selectedIntent"
      ></AllCodeModal>
      <!-- :selectedData="selectedIntentAllCodes" -->
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import ImportCodeModal from './ImportCodeModal.vue'
import AllCodeModal from './AllCodeModal.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'

export default {
  components: {
    DateFilter,
    ImportCodeModal,
    AllCodeModal,
    DatepickerCustomDialog
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD 23:59')
      },
      search: '',
      headers: [
        { text: 'Import Date', value: 'import_date', sortable: false },
        { text: 'Reply Comment Topic', value: 'replyCommentTopic', sortable: false },
        { text: 'Start Date', value: 'start_date', sortable: false },
        { text: 'End Date', value: 'end_date', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      dataDashboard: [],
      dataIntents: [],
      loading: false,
      showImpostCodeModal: false,
      showCodeModal: false,
      selectedIntentAllCodes: '',
      selectedIntent: null,
      advanceSearchModal: false,
      filter: {
        intent: '',
        voucher_start_date: '',
        voucher_end_date: '',
        status: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getVoucherDashboard()
    this.getVoucherIntent()
  },
  methods: {
    getVoucherDashboard() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
        end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
        limit: vm.limit,
        offset: vm.offset
      }

      if (vm.filter.intent) {
        Object.assign(data, { search: vm.filter.intent })
      }

      if (vm.filter.voucher_start_date) {
        Object.assign(data, { voucher_start_date: vm.filter.voucher_start_date })
      }

      if (vm.filter.voucher_end_date) {
        Object.assign(data, { voucher_end_date: vm.filter.voucher_end_date })
      }

      vm.loading = true
      api.postPlernVoucherDashboard(data, (err, response) => {
        if (response.responsecode == 200) {
          vm.dataDashboard = response.data
          vm.total = response.total
          vm.loading = false
        } else {
          console.log(err)
          return
        }
      })
    },
    getVoucherIntent() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      vm.loading = true
      api.getPlernVoucherCommentIntentName(data, (err, response) => {
        if (response.responsecode == 200) {
          vm.dataIntents = response.data
          vm.loading = false
        } else {
          console.log(err)
          return
        }
      })
    },
    // getAllCode(payload) {
    //   var vm = this;
    //   var data = {
    //     pageid: vm.selectedBot.pageid,
    //     intentname: payload,
    //   }

    //   api.postPlernGetCode(data, (err, response) => {
    //     if(response.responsecode == 200) {
    //       vm.selectedIntentAllCodes = response.data;
    //       vm.showCodeModal = true;
    //     } else {
    //       console.log(err);
    //       return
    //     }
    //   });
    // },
    onChangeStatus(item) {
      item.open = !item.open

      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        intentname: item.intentname,
        import_date: moment(item.import_date).format('YYYY-MM-DD'),
        open: item.open
      }

      api.postPlernUpdateStatus(data, (err, response) => {
        if (response.responsecode == 200) {
          vm.onRefresh()
        } else {
          console.log(err)
          return
        }
      })
    },
    onDelete(item) {
      var vm = this

      vm.$swal
        .fire({
          type: 'question',
          title: 'คุณต้องการลบ Intent นี้หรือไม่?',
          showCancelButton: true,
          confirmButtonText: vm.$t('Yes'),
          cancelButtonText: vm.$t('No'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: vm.selectedBot.pageid,
              intentname: item.intentname,
              import_date: moment(item.import_date).format('YYYY-MM-DD')
            }

            api.postPlernDeleteCode(data, (err, response) => {
              if (response.responsecode == 200) {
                vm.onRefresh()
              } else {
                console.log(err)
                return
              }
            })
          }
        })
    },
    onShowCode(item) {
      // this.getAllCode(item);
      this.selectedIntent = item
      this.showCodeModal = true
    },
    changePage(val) {
      var vm = this
      if (vm.pagetmp == val) {
        //dont do shit
      } else {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.getVoucherDashboard()
      }
    },
    onCloseShowCodeModal() {
      this.selectedIntent = ''
      this.showCodeModal = false
    },
    onRefresh() {
      this.selectedIntent = ''
      this.getVoucherDashboard()
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    clearSearch() {
      this.filter = {
        intent: '',
        voucher_start_date: '',
        voucher_end_date: '',
        status: ''
      }

      this.onSearch()
    },
    onSearch() {
      this.advanceSearchModal = false
      this.getVoucherDashboard()
    },
    closeSearchModal() {
      this.advanceSearchModal = false
      this.filter = {
        intent: '',
        voucher_start_date: '',
        voucher_end_date: '',
        status: ''
      }
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.pageNumber = 1
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/plern/VoucherCodeDetails.vue